<div>
    <div mat-dialog-title class="d-flex justify-content-between align-items-center details-div">
      <h1  style="font-size: inherit; font-weight: bold;text-align: center;">PRO-DEVICE AGENT DETAILS</h1>
        <div style="display: block;">
        <i class="fa fa-download custom-download details-download" (click)="downloadExcel()"></i>
        <i class="fa fa-window-close details-close" (click)="close()"></i>
        </div>
    </div>
    <div class="details-table">
        <table class="table table-bordered table-hover details-main">
            <thead>
              <tr>
                <th class="sticky-header">Potential ID</th>
                <th class="sticky-header">VPN IP</th>
                <th class="sticky-header">Environment</th>
                <th class="sticky-header">Version</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let obj of data; let i = index;">
                <td>{{obj.potentialId}}</td>
                <td>{{obj.vpnIp}}</td>
                <td>{{obj.environment}}</td>
                <td>{{obj.version}}</td>
              </tr>
            </tbody>
          </table>
      </div>
  </div>